module.exports = __webpack_public_path__ + "arrow.gif";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-start/assets/arrow.gif
// module id = 1165
// module chunks = 10